
import React from 'react'
import {connect} from "react-redux";
import {servidor, servicioRestfulCompleto, servicioRestfulMinimo, color_rojo, color_naranja} from "../Configuracion";
import {
    CELLTIPO_CADENA, CELLTIPO_COLOR,
    CELLTIPO_ENTERO, CELLTIPO_FECHA,
    CELLTIPO_FOREIGN, CELLTIPO_ICONOACCION, CELLTIPO_MEMO, COLUMNVISIBLE_SIEMPRE,
} from "../../framework2/ej2/UI/TiposCeldas";
import "../resources/css/encabezado.css";
import "../resources/css/selectorperiodo.css";
import FormularioBotonera, {
    BOTONERA_ACCION_NUEVO, BOTONERA_ACCION_REFRESCAR,
    BOTONERA_REFRESCAR
} from "../../framework2/ej2/UI/FormularioBotonera";
import ClienteRestful from "../../framework2/ej2/network/ClienteRestful";
import {Icon, Intent, Spinner} from "@blueprintjs/core";
import GridRDG from "../../framework2/adazzle/GridRDG";
import Titulo from "../../framework2/ej2/UI/Titulo";
import Tratamiento from "./Tratamiento";
import PropTypes from "prop-types";
import {
    COMPONENTE_TIPO_BOOL,
    COMPONENTE_TIPO_DATE,
    COMPONENTE_TIPO_FOREIGN,
    COMPONENTE_TIPO_FOREIGN_PANTALLA,
    COMPONENTE_TIPO_FOREIGN_SERVIDOR, COMPONENTE_TIPO_HTML,
    COMPONENTE_TIPO_INPUT, COMPONENTE_TIPO_MEMO,
    COMPONENTE_TIPO_SELECT,
    COMPONENTE_TIPO_SELECT_MULTI,
    loadDatos,
    loadDatosServicio,
    renderFormulario,
    renderGrid, renderTabla,
    showInputBusqueda,
    showSelectBusqueda
} from "../utils/FormularioUtils";
import {dientes, tiposPagos, zonas} from "../utils/Definiciones";
import Paciente from "./Paciente";
import SelectorPeriodo from "../../framework2/ej2/UI/SelectorPeriodo";
import Pago from "./Pago";
import {
    getPeriodoAgnoActualTimestamp,
    getPeriodoDiaActual,
    getPeriodoUltimoAgnoTimestamp
} from "../../framework2/ej2/utils/PeriodoUtils";
import Pacientes from "./Pacientes";
import Tabla, {CELLTIPO_HTML} from "../../framework2/ej2/UI/Tabla";

class Tratamientos extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showGrid: true,
            cargandoDatos: false,
            elementoSeleccionado: null,
            datos: [],
            elementoShow: false,
            marcaTiempo: new Date(),

            filtroFechas: getPeriodoUltimoAgnoTimestamp(),
            filtroDoctorCodigo: 0,
            filtroObservaciones: "",
            filtroDiente: "",
            filtroTipo: "",
        }

        this.columnas= [
            {campo: "M", titulo: "M", tipo: CELLTIPO_ICONOACCION,  ancho: 40,  visibilidad: COLUMNVISIBLE_SIEMPRE, fija: true,
                icon: "edit",
                onAccion: (elemento) => {
                    console.log(elemento);
                    this.setState({elementoSeleccionado: elemento, showGrid: false })
                }
            },
            {campo:"fecha", titulo: "Fecha", tipo: CELLTIPO_FECHA, ancho:80, fija: true,},
            {campo:"diente", titulo: "Dientes", tipo: CELLTIPO_CADENA, ancho:80},
            //{campo:"zona", titulo: "Zona", tipo: CELLTIPO_CADENA, ancho:120},
            {campo:"zonas", titulo: "Zonas", tipo: CELLTIPO_CADENA, ancho:80},
            //{campo:"tratamientotipoCodigo.nombre", titulo: "Tipo", tipo: CELLTIPO_CADENA, ancho:160,},
            {campo:"tratamientoTipos", titulo: "Tipo", tipo: CELLTIPO_MEMO, ancho: 200,},
            {campo:"observaciones", titulo: "Observaciones", tipo: CELLTIPO_HTML, ancho:300, filtroEncabezado: true,},
            {campo:"doctorCodigo.nombre", titulo: "Doctor", tipo: CELLTIPO_CADENA, ancho:100,},
            {campo:"clinicaCodigo.nombre", titulo: "Clínica", tipo: CELLTIPO_CADENA, ancho:100,},
        ];
        //console.log("props.paciente:", props.paciente);
        if (!props.paciente){
            this.columnas.splice(2, 0,
                {campo:"pacienteCodigo.nombre", titulo: "Paciente", tipo: CELLTIPO_CADENA, ancho:200,});
        }


        this.elementoConfig= {
            className: "Tratamiento",
            secciones: [
                {
                    titulo: "Datos ",
                    campos: [
                        {campo: "fecha", titulo: "Fecha", tipo: COMPONENTE_TIPO_DATE, cols: 1, obligatorio: true},
                        {campo: "pacienteCodigo", titulo: "Paciente", tipo: COMPONENTE_TIPO_FOREIGN_PANTALLA, cols: 3, obligatorio: true,
                            clase: 'com.ej2sistemas.dental.modelo.Paciente',
                            formulario: <Pacientes />
                        },
                        {campo: "diente", titulo: "Diente", tipo: COMPONENTE_TIPO_SELECT_MULTI, valores: dientes, cols: 2},
                        {campo: "zona", titulo: "Zona", tipo: COMPONENTE_TIPO_SELECT_MULTI, valores: zonas, cols: 2},
                        {campo: "tratamientotipoCodigo", titulo: "Tipo", tipo: COMPONENTE_TIPO_FOREIGN, valores: props.datosmaestros.tratamientotipos, cols: 2, obligatorio: true},
                        {campo: "tratamientotipo2Codigo", titulo: "Tipo", tipo: COMPONENTE_TIPO_FOREIGN, valores: props.datosmaestros.tratamientotipos, cols: 2, obligatorio: false},
                        {campo: "tratamientotipo3Codigo", titulo: "Tipo", tipo: COMPONENTE_TIPO_FOREIGN, valores: props.datosmaestros.tratamientotipos, cols: 2, obligatorio: false},
                        //{campo: "observaciones", titulo: "Observaciones", tipo: COMPONENTE_TIPO_MEMO, cols: 4, rows:3},
                        {campo: "observaciones", titulo: "Observaciones", tipo: COMPONENTE_TIPO_HTML, cols: 4},
                        {campo: "clinicaCodigo", titulo: "Clínica", tipo: COMPONENTE_TIPO_FOREIGN, valores: props.datosmaestros.clinicas, cols: 2},
                        {campo: "doctorCodigo", titulo: "Doctor", tipo: COMPONENTE_TIPO_FOREIGN, valores: props.datosmaestros.doctores, cols: 2, obligatorio: true},
                        {campo: "pendiente", titulo: "Pendiente", tipo: COMPONENTE_TIPO_BOOL, valores: props.pendiente, cols: 1},
                    ]
                },

            ]
        };

    }

    componentDidMount() {
        this.loadDatos();
    }


    loadDatos= () =>{
        const {filtroDoctorCodigo, filtroFechas, filtroObservaciones, filtroTipo, filtroDiente} = this.state;
        const {estado, paciente} = this.props;

        let parametros= {
            clinicaCodigo: estado.clinica.codigo,
            pacienteCodigo: paciente ? paciente.codigo : 0,
            doctorCodigo: filtroDoctorCodigo ? filtroDoctorCodigo : 0,
            fechas: filtroFechas,
            observaciones: filtroObservaciones,
            diente: filtroDiente,
            tipo: filtroTipo,
        }

        //console.log("TRATAMIENTOS LOADDATOS");
        //console.log("parametos: ", parametros);
        loadDatosServicio(this, "Tratamiento", "getLista", parametros);
    }

    //------------------------------------------------------------------------------------------------------------------
    // ACCIONES
    //------------------------------------------------------------------------------------------------------------------

    onAccion= (accion, elemento) => {
        switch (accion){
            case BOTONERA_ACCION_NUEVO:
                this.nuevoElemento();
                break;

            case BOTONERA_ACCION_REFRESCAR:
                this.loadDatos();
                break;
        }
    }

    nuevoElemento= () => {
        const {estado, paciente} = this.props;

        console.log("TRATAMIENTO");
        console.log("NUEVO ELEMENTO");
        console.log("paciente: ", paciente);

        let elemento= {
            fecha: new Date(),
            clinicaCodigo: estado.clinica,
            pacienteCodigo: paciente ? paciente : null,
            doctorCodigo: paciente && paciente.doctorCodigo ? paciente.doctorCodigo : null,
            tratamientotipoCodigo: { codigo: 9999, nombre: "NO DEFINIDO"},
            tratamientotipo2Codigo: { codigo: 9999, nombre: "NO DEFINIDO"},
            tratamientotipo3Codigo: { codigo: 9999, nombre: "NO DEFINIDO"},
            pendiente: false,
        } ;



        console.log("Nuevo Elemento");
        this.setState({elementoSeleccionado: elemento, showGrid: false});

    }

    onFormularioAceptado= () => {
        this.setState({showGrid: true}, () => this.loadDatos(this, "Tratamiento"));
    }

    eliminarElemento= () => {
        const {elementoSeleccionado } = this.state;
        const {auth} = this.props;
        console.log(">>>eliminarElemento: ", elementoSeleccionado);
        let url= servidor + servicioRestfulMinimo + "Tratamiento/" + elementoSeleccionado.codigo + "/0/"+ auth.usuarioCodigo;
        const clienteRestful = new ClienteRestful().setUrl(url);
        clienteRestful.doDelete( response => {
            this.loadDatos();
        });
    }

    renderBusqueda= () => {
        const {filtroDoctorCodigo, filtroObservaciones, filtroDiente, filtroTipo } = this.state;
        const {datosmaestros} = this.props;
        return (
            <div class="fr_contenedor_buscador" >
                <SelectorPeriodo className={"fr_selectorPeriodo"}
                                 titulo={"Periodo fechas"} tipoValor={27}
                                 onChange={ (periodo) => this.setState({filtroFechas: periodo} )}
                                 tiposOcultos={[22,23,25,26]}
                                 width={400}
                />

                {showInputBusqueda("diente", "Diente", filtroDiente,
                    (diente) => this.setState({filtroDiente: diente.toUpperCase()}),
                    this.loadDatos) }

                {/*showInputBusqueda("tipo", "Tipo", filtroTipo,
                    (tipo) => this.setState({filtroTipo: tipo.toUpperCase()}),
                    this.loadDatos) */}

                {/*showSelectBusqueda("sTipos",  "Tipo", filtroTipo, tiposPagos,
                    (tipoCodigo) => this.setState({filtroTipo: tipoCodigo}),
                    this.loadDatos) */}

                {showInputBusqueda("observaciones", "Observaciones", filtroObservaciones,
                    (observaciones) => this.setState({filtroObservaciones: observaciones.toUpperCase()}),
                        this.loadDatos) }

                {/* showSelectBusqueda("sDoctores",  "Doctor", filtroDoctorCodigo, datosmaestros.doctores,
                    (doctorCodigo) => this.setState({filtroDoctorCodigo: Number(doctorCodigo)})   )  */}

                <button className="fr_boton refrescar"onClick={this.loadDatos}><Icon icon="refresh" style={{marginRight: 6}}/>Refrescar</button>
                <button className="fr_boton aceptar"onClick={this.nuevoElemento}><Icon icon="document" style={{marginRight: 6}}/>Nuevo</button>

            </div>
        );
    }

    estilizadorRow= (elemento) => {
        //console.log("estilizadorRow");
        //console.log("elemento: ", elemento);
        if (Boolean(elemento.pendiente))
            return {backgroundColor: color_naranja};
    }
    render() {
        const {showGrid, datos} = this.state;
        const {paciente} = this.props;
        let propiedades= {
            height: 800,
            estilizadorRow: this.estilizadorRow,
            mostrarEliminar: true,
        };
        console.log("props.datosmaestros.tratamientotipos: ", this.props.datosmaestros.tratamientotipos);
        return (
            <div style={{margin: 8, padding: 4}}>
                {!paciente && <Titulo titulo="Gestión de Tratamientos" soloTitulo={true}/> }
                {Boolean(showGrid) &&
                    <>
                        {this.renderBusqueda()}
                        {renderTabla(this, datos, this.onAccion, propiedades)}
                        {/*renderGrid(this, "Tratamientos", datos, this.onAccion, propiedades)*/}
                    </>
                }
                {!Boolean(showGrid) && renderFormulario(this, <Tratamiento paciente={paciente}/>)}

            </div>
        )
    }

}

Tratamientos.propTypes = {
    paciente: PropTypes.object,
    llamador: PropTypes.object,
}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
        datosmaestros: state.datosmaestros,
        estado: state.estado,
    }
}
export default connect(mapStateToProps)(Tratamientos);



